module.controller('clientHomeCtrl', [ '$scope', '$rootScope', '$state', 'clientService', 'alertService', 'clientHomeDataResolve', clientHomeCtrlFn ]);
function clientHomeCtrlFn($scope, $rootScope, $state, clientService, alertService, clientHomeData) {

	$scope.idClient = $state.params.id;
	$scope.clientHome = {

	};
	$scope.loading = false;

	/**
	 * 
	 * @param idUser
	 */
	$scope.loadHomeInfo = function(idClient) {
		$scope.loading = true;

		// clientService.getHomeClient(idClient).then(function(response) {
		$scope.loading = false;
		var responseData = clientHomeData.getData();// response.getData();
		$scope.clientHome = responseData;

		// }, function(response) {
		// $scope.loading = false;
		// });
	};

	/**
	 * 
	 */
	$scope.create = function() {
		alertService.showSwtQuestion('Crear Cliente', function() {
			$scope.loading = true;

			var createModel = {
				name : $scope.client.name,
				businessName : $scope.client.businessName,
				idIdentificationType : $scope.client.idType.selected[0].id,
				identificationNumber : $scope.client.identificationNumber,
				mainAddress : $scope.client.mainAddress
			};

			clientService.createClient(createModel).then(function(response) {
				$scope.loading = false;
				$state.go('home.clientList');
				alertService.showSuccess('Cliente creado satisfactoriamente');
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	/**
	 * 
	 */
	$scope.update = function() {
		alertService.showSwtQuestion('Actualizar Cliente', function() {
			$scope.loading = true;

			var updateModel = {
				username : $scope.user.username,
				visible : $scope.user.visible,
				firstName : $scope.user.firstName,
				lastName : $scope.user.lastName,
				email : $scope.user.email
			};

			clientService.updateClient($scope.idUser, updateModel).then(function(response) {
				$scope.loading = false;
				$state.go('home.clientList');
				alertService.showSuccess('Cliente actualizado satisfactoriamente');
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	$scope.changeClientState = function(idClient, clientInfo) {
		
		var	state = clientInfo.active;
		
		if (state) {
			clientService.enableClient(idClient).then(function(response) {
				$scope.loading = false;
				alertService.showSuccess('Cliente activo nuevamente en el sistema');
			}, function(response) {
				$scope.loading = false;
				clientInfo.active = false;
			});
		} else {
			clientService.disableClient(idClient).then(function(response) {
				$scope.loading = false;
				alertService.showSuccess('Cliente inactivo');
			}, function(response) {
				$scope.loading = false;
				clientInfo.active = true;
			});
		}
	};

	$scope.loadHomeInfo($scope.idClient);

}
